/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SuggestedSearchType = {
    UpcomingTrips: 'upcoming trips',
    RecentSearches: 'recent searches',
    PopularDestinations: 'popular destinations',
    UpcomingHolidays: 'upcoming holidays',
    PopularOnGondola: 'popular on gondola',
    Default: 'default'
} as const;
export type SuggestedSearchType = typeof SuggestedSearchType[keyof typeof SuggestedSearchType];


export function instanceOfSuggestedSearchType(value: any): boolean {
    for (const key in SuggestedSearchType) {
        if (Object.prototype.hasOwnProperty.call(SuggestedSearchType, key)) {
            if (SuggestedSearchType[key as keyof typeof SuggestedSearchType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SuggestedSearchTypeFromJSON(json: any): SuggestedSearchType {
    return SuggestedSearchTypeFromJSONTyped(json, false);
}

export function SuggestedSearchTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuggestedSearchType {
    return json as SuggestedSearchType;
}

export function SuggestedSearchTypeToJSON(value?: SuggestedSearchType | null): any {
    return value as any;
}

export function SuggestedSearchTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): SuggestedSearchType {
    return value as SuggestedSearchType;
}

